export const REDIRECT_URL_LS_KEY = 'returnUrl';
